import React from "react";
import { BaseApp } from "../base/App";
import { MISSION_CONFIG } from "./missionConfig";
import MissionGpt from "./MissionGpt";
import MissionDalle from "./MissionDalle";
import { MissionPosterEditor } from "./MissionPosterEditor";
import { MissionVoice } from "./MissionVoice";
import MissionVideo from "./MissionVideo";

export default function MissionApp() {
  return (
    <BaseApp
      config={MISSION_CONFIG}
      components={{
        Gpt: MissionGpt,
        Dalle: MissionDalle,
        PosterEditor: MissionPosterEditor,
        Voice: MissionVoice,
        Video: MissionVideo,
      }}
    />
  );
}
